import { toast } from "react-toastify";
import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export const GenerateOtpAsync = async (
  email: string,
  t: (key: string) => string
): Promise<{ isRegisteredUser: boolean } | null> => {
  if (!navigator.onLine) {
    toast.error(t("internetConnection"), { toastId: "offline-error" });
    return null;
  }

  try {
    const baseUrl = getApiBaseUrl();

    const response = await fetch(
      `${baseUrl}/api/Account/GenerateOtpAsync`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to generate OTP");
    }

    return await response.json();
  } catch (error) {
    console.error("Error generating OTP:", error);
    throw error;
  }
};
